import { K_JQUERY, K__UP, K_HEAD } from 'up.lib.js.constants';

const min_days_out = 10;
const _MS_PER_DAY = 1000 * 60 * 60 * 24;

// http://stackoverflow.com/questions/3224834/get-difference-between-2-dates-in-javascript
// a and b are javascript Date objects
function dateDeltaInDays(a, b) {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function filterDateFrom(outbound, days_out = min_days_out) {
  const outbound_date = new Date(outbound);
  const now = new Date();
  const difference = dateDeltaInDays(now, outbound_date);
  return difference >= days_out;
}

// https://stackoverflow.com/a/7091965
// birthday is a javascript Date object
export function getAge(birthday) {
  const today = new Date();
  let age = today.getFullYear() - birthday.getFullYear();
  const m = today.getMonth() - birthday.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
    age--;
  }
  return age;
}

function periodicallyCheckHelper(selector, function_to_call, interval_id) {
  const element = document.querySelector(selector);
  if (element !== null) {
    clearInterval(interval_id);
    function_to_call();
  }
}

export function periodicallyCheckThenDo(selector, freq, function_to_call) {
  const interval_id = setInterval(function () {
    periodicallyCheckHelper(selector, function_to_call, interval_id);
  }, freq);
}

function periodicallyCheckWithinHelper(container, selector, function_to_call, interval_id) {
  const parent = document.querySelector(container);
  if (parent !== null) {
    const element = parent.querySelector(selector);
    if (element !== null) {
      clearInterval(interval_id);
      function_to_call();
    }
  }
}

export function periodicallyCheckForVisibilityThenDo(
  container,
  selector, freq, function_to_call
) {
  const interval_id = setInterval(function () {
    periodicallyCheckWithinHelper(container, selector, function_to_call, interval_id);
  }, freq);
}

export function neverStopDoing(freq, function_to_call) {
  setInterval(function_to_call, freq);
}


export function waitForJQueryThen(freq, callback, jQueryProp = K_JQUERY) {
  const interval_id = setInterval(function () {
    const jq = isJQuery(jQueryProp);
    if (jq && jq !== 'undefined' && isFn(callback)) {
      clearInterval(interval_id);
      callback();
    }
  }, freq);
}


export function isJQueryThere(frequency_ms, n, fn_success, fn_fail, jQueryProp = K_JQUERY) {
  let counter = -1;

  const interval_id = setInterval(function () {
    counter += 1;
    // try for n times
    if (counter <= n) {
      if (isJQuery(jQueryProp)) {
        // success
        clearInterval(interval_id);
        if (isFn(fn_fail)) {
          fn_success();
        }
      }
    } else {
      // bail and fail
      clearInterval(interval_id);
      if (isFn(fn_fail)) {
        fn_fail();
      }
    }
  }, frequency_ms);
}


export function zeroPad(num_int) {
  let num_str = num_int.toString();
  if (num_str.length < 2) {
    num_str = `0${num_str}`;
  }
  return num_str;
}

export function elementsExistMap(mapOfSelectors) {
  const keys = Object.keys(mapOfSelectors);
  for (let i = 0; i < keys.length; i++) {
    const elements = document.querySelectorAll(mapOfSelectors[keys[i]]);
    if (elements.length === 0) {
      return keys[i];
    }
  }
  return 'ok';
}


export function parsePrice(totalTxt, returnCents = true) {
  if (!isStr(totalTxt)) {
    return 0;
  }
  let price_f = parseFloat(totalTxt.replace(/[+\s/$,[a-zA-Z:]/g, ''));
  // IE does not support Number.IsNaN, but that is the preferred method in other browsers
  const isItNaN = Number.isNaN || isNaN; /* eslint-disable-line no-restricted-globals */
  price_f = isItNaN(price_f) ? 0 : price_f;
  return (returnCents) ? Math.round(price_f * 100) : price_f;
}


export function roundUpIntCentsToDollars(price) {
  const dollars = parseFloat(price) / 100;
  return Math.ceil(dollars).toFixed(0);
}


export function formatAPR(apr, do_not_round = false, is_cents = true) {
  const apr_f = (is_cents) ? parseFloat(apr) / 100 : parseFloat(apr);
  return (do_not_round) ? apr_f.toFixed(2) : Math.floor(apr_f).toFixed(0);
}


export function formatDateStrSlashSplitToKasa(date, y_prefix = '20') {
  const split_date = date.split('/');
  const yyyy = (split_date[2].length < 4) ? (y_prefix + split_date[2]) : split_date[2];
  const mm = zeroPad(split_date[0]);
  const dd = zeroPad(split_date[1]);
  return yyyy + mm + dd;
}

/** formatDateHumanToKasa()
*   Function that converts human readable date to KASA format.
 *
 *  Params:  dateStr     = string
 *           year        = string
 *           yearPrefix  = string
 *
 *  Acceptable formats:
 *           Sepember 5, 2017
 *           Sep 05, 17
*/

export function formatDateHumanToKasa(dateStr = '', year = '', yearPrefix = '20') {
  // error checking
  if (!isStr(dateStr, false)) return '';

  dateStr = dateStr.trim();

  const dateArr = dateStr.split(' ');

  // error checking
  if (dateArr.length < 2) return '';

  const months = {
    jan: '01',
    feb: '02',
    mar: '03',
    apr: '04',
    may: '05',
    jun: '06',
    jul: '07',
    aug: '08',
    sep: '09',
    oct: '10',
    nov: '11',
    dec: '12'
  };

  // get month
  const mm = months[dateArr[0].toLowerCase().substr(0, 3)];

  // get day
  let dd = dateArr[1].match(/\d{1,2}/g);

  // get year
  let yyyy = year === '' ? dateArr[2] : year;

  // error checking
  if (mm === undefined
        || dd === undefined
        || !dd
        || dd.length !== 1
        || yyyy === undefined
        || !yyyy
        || (yyyy.length !== 2 && yyyy.length !== 4)
  ) return '';

  if (dd[0].length < 2) dd = `0${dd[0]}`;
  if (isStr(yyyy) && yyyy.length === 2) yyyy = `${yearPrefix}${yyyy}`;

  return `${yyyy}${mm}${dd}`;
}

export function formatDateJsToKasa(d) {
  const js_month = d.getMonth() + 1;
  const js_day = d.getDate();
  return d.getFullYear().toString() + zeroPad(js_month) + zeroPad(js_day);
}


export function formatDateJsToKasaDOB(d) {
  const js_month = d.getMonth() + 1;
  const js_day = d.getDate();
  return `${zeroPad(js_month)}/${zeroPad(js_day)}/${d.getFullYear().toString()}`;
}

export function upReady(callback) {
  if (isFn(callback)) {
    if (document.readyState === 'complete' || document.readyState === 'loaded' || document.readyState === 'interactive') {
      // document is ready™ to go
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }
}

export function getIn(obj, path, default_val = null) {
  // if source object is null,undefined or not of type object return default value
  if (typeof obj === 'undefined' || obj === null || typeof obj !== 'object') {
    return default_val;
  }
  if (path === null) {
    return obj;
  }
  let path_var = obj;
  if (Array.isArray(path)) {
    for (let i = 0; i < path.length; i++) {
      if (path_var !== null && typeof path_var !== 'undefined' && path[i] in path_var) {
        path_var = path_var[path[i]];
      } else {
        return default_val;
      }
    }
  } else {
    return default_val;
  }

  if (path_var === undefined) {
    return default_val;
  }
  return path_var;
}

export function log(...args) {
  window.console.log(...['>>> up', ...args]);
}

export function logt(...args) {
  log(...args);
  const trace = 'trace';
  if (trace in window.console && isFn(window.console[trace])) {
    window.console[trace]();
  }
}

export function whenURLMatchesRun(this_string, callback) {
  const matches = window.location.href.match(this_string);
  if (matches && matches.length > 0 && isFn(callback)) {
    callback();
  }
}

export function extractHumanReadableDate(raw_string) {
  const expression = /\d{1,2}[/]\d{1,2}[/]\d{2,4}/;
  const arr = raw_string.match(expression) || [];
  return (arr.length > 0) ? arr[0] : '';
}

export function isFn(f) {
  return (f && typeof f === 'function');
}

export function isJQuery(jQueryProp = K_JQUERY) {
  return (jQueryProp in window && typeof isFn(window[jQueryProp]));
}

export function loadJs(src, callback) {
  const script = document.createElement('script');
  let loaded;
  script.setAttribute('src', src);
  if (callback) {
    script.onload = function () {
      if (!loaded) {
        callback.call();
      }
      loaded = true;
    };
  }
  document.getElementsByTagName(K_HEAD)[0].appendChild(script);
}

export function writeCookie(name, value, days, domain = '') {
  let expires;
  let cookie_value;

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  } else {
    expires = '';
  }

  cookie_value = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/`;

  // when domain is localhost, best way to delete cookie is to omit domain
  if (domain !== '') {
    cookie_value += `; domain=${domain}`;
  } else {
    const o = window.location.host.match(/\.[\w-]+\.\w{2,3}(:\d+)?$/);
    if (o && o[0]) {
      cookie_value += `; domain=${o[0]}`;
    }
  }
  document.cookie = cookie_value;
}

export function readCookie(name) {
  const name_eq = `${encodeURIComponent(name)}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(name_eq) === 0) return decodeURIComponent(c.substring(name_eq.length, c.length));
  }
  return null;
}

export function deleteCookie(name, domain = '') {
  if (domain !== '') {
    writeCookie(name, '', -1, domain);
  } else {
    const o = window.location.host.match(/\.[\w-]+\.\w{2,3}(:\d+)?$/);
    if (o && o[0]) {
      writeCookie(name, '', -1, o[0]);
    } else {
      writeCookie(name, '', -1, domain);
    }
  }
}

export function getQueryMap() {
  const query = {};
  const a = window.document.location.search.substr(1).split('&');
  for (let i = 0; i < a.length; i++) {
    const b = a[i].split('=');
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '');
  }
  return query;
}

export function isUnderThreshold(threshold) {
  const cid = readCookie(K__UP);
  if (cid === null) {
    log('Oops! Check the platform cookie, cid is null!');
    return false;
  }
  const values = cid.split('.');
  if (values.length < 3) {
    return false;
  }
  const client_id = values[2];
  const ticket_number = parseInt(client_id.substring(client_id.length - 2), 10);
  return (ticket_number < threshold);
}

export function caseInsensitiveMatch(haystack, needle) {
  if (isStr(haystack)) {
    if (isStr(needle)) {
      const result = haystack.toLowerCase().match(needle.toLowerCase());
      return (!!result && result.length > 0);
    }

    if (needle.constructor === Array) {
      return needle.reduce((matchedSoFar, curr) => {
        if (!isStr(curr)) return false;
        return matchedSoFar
          ? haystack.toLowerCase().match(curr.toLowerCase())
          : false;
      }, true);
    }
  }
  return false;
}

export function matchesURL(needle) {
  return caseInsensitiveMatch(window.location.href, needle);
}

export function matchesTitle(needle) {
  return caseInsensitiveMatch(document.title, needle);
}

export function waitForSelExe(cc_sel, callback, freq) {
  const clear_after_cevent = setInterval(function () {
    if (document.querySelector(cc_sel) !== null) {
      callback();
      clearInterval(clear_after_cevent);
    }
  }, freq);
}

export function arrayCmpr(arr_1, arr_2, ignored_keys = []) {
  if (bothNullOrBothUndefined(arr_1, arr_2)) {
    return true;
  } if (checkAnyNullOrUndefined(arr_1, arr_2)) {
    return false;
  }
  if (!bothAreArrays(arr_1, arr_2)) return false;

  const len_1 = arr_1.length;
  const len_2 = arr_2.length;
  let index = 0;

  if (len_1 !== len_2) {
    return false;
  }

  for (; index < len_1; index++) {
    if (!cmpr(arr_1[index], arr_2[index], ignored_keys)) {
      return false;
    }
  }
  return true;
}

export function mapCmpr(map_1, map_2, ignored_keys = []) {
  if (bothNullOrBothUndefined(map_1, map_2)) {
    return true;
  } if (checkAnyNullOrUndefined(map_1, map_2)) {
    return false;
  }
  if (
    bothAreArrays(map_1, map_2) ||
      isArr(map_1) ||
      isArr(map_2) ||
      !isObj(map_1) ||
      !isObj(map_2)
  ) return false;

  const keys_1 = Object.keys(map_1);
  const keys_2 = Object.keys(map_2);
  let index = 0;

  const len_1 = keys_1.length;
  const len_2 = keys_2.length;

  if (len_1 !== len_2 && ignored_keys.length === 0) {
    return false;
  }

  for (; index < len_1; index++) {
    if (ignored_keys.indexOf(keys_1[index]) === -1) {
      if (!cmpr(map_1[keys_1[index]], map_2[keys_1[index]], ignored_keys)) {
        return false;
      }
    }
  }
  return true;
}

export function cmpr(obj_1, obj_2, ignored_keys = []) {
  if (bothAreArrays(obj_1, obj_2)) {
    return arrayCmpr(obj_1, obj_2, ignored_keys);
  }

  if (bothNotArrays(obj_1, obj_2)) {
    return mapCmpr(obj_1, obj_2, ignored_keys);
  }

  if (
    (isStr(obj_1) && isStr(obj_2))
    || (isNum(obj_1) && isNum(obj_2))
    || (typeof obj_1 === 'boolean' && typeof obj_2 === 'boolean')
  ) {
    return obj_1 === obj_2;
  }

  return obj_1 === undefined && obj_2 === undefined;
}

function checkAnyNullOrUndefined(obj_1, obj_2) {
  return obj_1 === null || obj_1 === undefined || obj_2 === null || obj_2 === undefined;
}

function bothNullOrBothUndefined(obj_1, obj_2) {
  return (obj_1 === null && obj_2 === null) || (obj_1 === undefined && obj_2 === undefined);
}

function bothAreArrays(obj_1, obj_2) {
  return Array.isArray(obj_1) && Array.isArray(obj_2);
}

function bothNotArrays(obj_1, obj_2) {
  return bothTypeObject(obj_1, obj_2) && !Array.isArray(obj_1) && !Array.isArray(obj_2);
}

function bothTypeObject(obj_1, obj_2) {
  return typeof obj_1 === 'object' && typeof obj_2 === 'object';
}

export function getCreditCard(selector) {
  const ret = {};
  const cc = document.getElementById(selector).value;

  ret.card_bin = cc.slice(0, 6);
  ret.card_last4 = (cc.length > 15) ? cc.slice(-4) : '';
  return ret;
}

export function assignObj(dest, src) {
  if (isObj(dest) &&
      isObj(src)) {
    const ks = Object.keys(src);
    let len = ks.length;

    for (; --len >= 0;) {
      const k = ks[len];
      dest[k] = src[k];
    }
  }
}

export function deepAssignObj(dest, src) {
  if (
    (isObj(dest) && !Array.isArray(dest)) &&
    (isObj(src) && !Array.isArray(src))
  ) {
    const ks = Object.keys(src);
    let len = ks.length;

    for (; --len >= 0;) {
      const k = ks[len];
      if (isObj(src[k]) && !Array.isArray(src[k]) && isObj(dest[k]) && !Array.isArray(dest[k])) {
        deepAssignObj(dest[k], src[k]);
      } else {
        dest[k] = src[k];
      }
    }
  }
}

export function isInArray(arr, element) {
  if (Array.isArray(arr)) {
    const len = arr.length;

    for (let i = 0; i < len; i++) {
      if (arr[i] === element) {
        return true;
      }
    }
  }
  return false;
}

export function formatPriceWithDelimiter(price, delimiter) {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
}

/** kasaPriceFormat
 *
 * @param price
 * @param regex_pattern Has the default parsePrice Format with the ability to cutomize
 * @returns {number}
 */


export function kasaPriceFormat(price, regex_pattern = /[+\s/$,.[a-zA-Z:]/g) {
  if (!isStr(price)) {
    return 0;
  }
  let price_f = parseFloat(price.replace(regex_pattern, ''));
  // IE does not support Number.IsNaN, but that is the preferred method in other browsers
  const isItNaN = Number.isNaN || isNaN; /* eslint-disable-line no-restricted-globals */
  price_f = isItNaN(price_f) ? 0 : price_f;
  return price_f;
}

export function isObj(elem) {
  return elem && typeof elem === 'object';
}

export function isStr(elem, isEmptyAllowed = true) {
  const isString = elem && typeof elem === 'string';

  return isEmptyAllowed
    ? isString
    : isString && elem !== '';
}

export function isArr(elem) {
  return elem && Array.isArray(elem);
}

export function isNum(elem, isZeroAllowed = true) {
  const isNumber = elem !== null && typeof elem === 'number';

  return isZeroAllowed
    ? isNumber
    : isNumber && elem !== 0;
}

export function safeFn(fn) {
  return (...args) => (isFn(fn)
    ? fn(...args)
    : null);
}

export function isInArr(arr, val) {
  if (!isArr(arr) || !val) {
    return false;
  }

  const len = arr.length;

  for (let i = 0; i < len; i++) {
    if (arr[i] === val) {
      return true;
    }
  }

  return false;
}

export function isHTMLElement(obj) {
  if (!obj || obj === undefined) {
    return false;
  }

  try {
    // Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  } catch (e) {
    // Browsers not supporting W3 DOM2 don't have HTMLElement and
    // an exception is thrown and we end up here. Testing some
    // properties that all elements have. (works on IE7)
    return isObj(obj) &&
      isObj(obj.style) &&
      isObj(obj.ownerDocument) &&
      obj.nodeType === 1;
  }
}

export function isInViewport(elem) {
  if (elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  return false;
}


/** jsonToArray
 *
 * @param jsonData needs to be an Obj {}
 * @param addIDKey Has the default val of false , if you need the parsing key to be present
 * in the obj make this true
 * @param idName is the key name for parsed keys to be in the obj
 * @returns {Object}
 */

export function jsonToArray(jsonData, addIDKey = false, idName) {
  if (isObj(jsonData)) {
    const arr = [];
    const objLen = Object.keys(jsonData).length;
    for (let i = 0; i < objLen; i++) {
      const keys = Object.keys(jsonData)[i];
      const newJson = jsonData[keys];
      if (addIDKey &&
      idName &&
      isStr(idName, false) &&
      isObj(newJson)) {
        newJson[idName] = keys;
      }
      arr.push(newJson);
    }
    return arr;
  }
  return jsonData;
}

